import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const PageStack = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})

const HeroBlock = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    paddingX: '4px',
    paddingY: '12px',
  },
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '36px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-1px',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '17px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const StatRow = styled(motion.div, {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    paddingX: '4px',
  },
})

const StatLabel = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const ViewToggleGroup = styled('div', {
  base: {
    display: 'inline-flex',
    backgroundColor: '#FFFFFF',
    borderRadius: 'pill',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    padding: '4px',
    gap: '4px',
  },
})

const ViewToggleButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    paddingX: '14px',
    paddingY: '6px',
    borderRadius: 'pill',
    border: 'none',
    backgroundColor: 'transparent',
    color: 'quickpass.inkSoft',
    cursor: 'pointer',
    transition:
      'background-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      color: 'quickpass.primary',
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: '0.5',
    },
  },
  variants: {
    isActive: {
      true: {
        backgroundColor: 'quickpass.primary',
        color: '#FFFFFF',
        _hover: {
          color: '#FFFFFF',
        },
      },
    },
  },
})

const ResultsGrid = styled(motion.div, {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '16px',
  },
})

const LoadMoreRow = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'center',
    paddingY: '24px',
  },
})

const EmptyState = styled('div', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '48px 32px',
    textAlign: 'center',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
})

const EmptyEmoji = styled('span', {
  base: {
    fontSize: '48px',
    lineHeight: '1',
  },
})

const EmptyTitle = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const EmptyBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    margin: '0',
    maxWidth: '440px',
    lineHeight: '1.5',
  },
})

const SkeletonCard = styled('div', {
  base: {
    height: '320px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px solid #F1ECFF',
    opacity: '0.55',
  },
})

const MapPlaceholder = styled('div', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '64px 32px',
    textAlign: 'center',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
})

export {
  PageStack,
  HeroBlock,
  PageTitle,
  PageSubtitle,
  StatRow,
  StatLabel,
  ViewToggleGroup,
  ViewToggleButton,
  ResultsGrid,
  LoadMoreRow,
  EmptyState,
  EmptyEmoji,
  EmptyTitle,
  EmptyBody,
  SkeletonCard,
  MapPlaceholder,
}
